module.exports = __webpack_public_path__ + "img/training-and-schulungen.895db631.svg";